/**
 * Admin role constants: used by both frontend and backend.
 */

export const ADMIN_ROLES = [
    'Administrator',
    'Data analyst',
    'Customer success',
    'Data manager',
    'Developer',
    'Marketing',
] as const;

export type AdminRole = (typeof ADMIN_ROLES)[number];
